import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Section = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const SubSection = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const SubSectionTitle = styled('div')<{ theme?: TTheme }>`
    color: ${({ theme }) => theme.colors.greys[900]};
`
